import React, { createContext, useContext, useState, useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";
import MMHeadImg from "../assets/img/MM_Head.png";

const LoaderContext = createContext();

export const useLoader = () => useContext(LoaderContext);

const spinStyle = {
  width: 40,
  height: 40,
  animation: "mm-spin-cw 1.2s linear infinite",
};

const LoaderOverlay = () => (
  <div
    style={{
      position: "fixed",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      backgroundColor: "rgba(255, 255, 255, 1)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 9999,
    }}
  >
    <style>{`
      @keyframes mm-spin-cw {
        from { transform: rotate(0deg); }
        to   { transform: rotate(360deg); }
      }
    `}</style>
    <img src={MMHeadImg} alt="Loading..." style={spinStyle} />
  </div>
);

export const LoaderProvider = ({ children }) => {
  const [loading, setLoading] = useState(false);
  // True on initial mount (suppresses page refresh load).
  // Set true again only when navigating via the module selector (isModuleSwitch flag).
  // Regular sidebar page navigations (Brand, Category, etc.) are NOT suppressed.
  const suppress = useRef(true);
  const history = useHistory();

  useEffect(() => {
    return history.listen((location) => {
      if (location.state?.isModuleSwitch) {
        suppress.current = location.state?.section !== "Sales";
        setLoading(false);
      }
    });
  }, [history]);

  const showLoader = () => {
    if (suppress.current) return;
    setLoading(true);
  };

  const hideLoader = () => {
    suppress.current = false;
    setLoading(false);
  };

  return (
    <LoaderContext.Provider value={{ loading, showLoader, hideLoader }}>
      {children}
      {loading && <LoaderOverlay />}
    </LoaderContext.Provider>
  );
};
